import { WebApiRequest, HTTP_GET, HTTP_PUT, HTTP_POST } from "tools/webservice";
import { RelatedCaseResponse } from "interfaces/Mueller.Business.Models";

export const getRelatedCases = (controlIdNumber: number, successCallback: (data: RelatedCaseResponse[]) => void, mountedRef: React.MutableRefObject<boolean>) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/homeowner/cases/${controlIdNumber}/related-cases`,
    successCallback,
    mountedRef,
  });
